import { plmTabClick } from 'analytics/eventDefinitions'
import { addGTMEvent } from 'api/googleTagManager'
import ButtonGroupToggle from 'components/Common/ButtonGroupToggle'
import { ButtonToggleItem } from 'components/Common/ButtonGroupToggle/ButtonGroupToggleItem'
import { mediaQueryUp } from 'components/utils/breakpoint'
import useGlobalSearchURLHashVertical from 'hooks/GlobalSearch/useGlobalSearchURLHashVertical'
import { rem } from 'polished'
import React, { useCallback, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import { getPeopleLikeMeEntryExperimentVariant } from 'selectors/searchSelectors'
import styled from 'styled-components'

const destinationSearchToggle: ButtonToggleItem = {
  id: 'destination-tab',
  label: 'I have a destination',
}

interface Props {
  onSelectDestination?: () => void
  onSelectInspiration?: () => void
}

interface MappedStateProps {
  inspirationTabText: string
}

const StyledContainer = styled.div`
  margin-bottom: ${rem(24)};
  width: 100%;
  ${mediaQueryUp.tablet} {
    display: flex;
    margin-top: ${rem(24)};
  }
`

const StyledButtonGroupToggle = styled(ButtonGroupToggle)`
  > * {
    padding: 0 ${rem(24)};
  }
`

function SearchTypeToggle(props: Props & MappedStateProps) {
  const { onSelectDestination, onSelectInspiration, inspirationTabText } = props
  const inspirationSearchToggle: ButtonToggleItem = useMemo(() => (
    {
      id: 'inspiration-tab',
      label: inspirationTabText,
    }
  ), [inspirationTabText])
  const { openedSearchVertical, toggleSearchVertical, option } = useGlobalSearchURLHashVertical()
  const [searchType, setSearchType] = useState<ButtonToggleItem>(option === 'inspiration' ? inspirationSearchToggle : destinationSearchToggle)
  const onButtonToggle = useCallback((item) => {
    if (item === destinationSearchToggle) {
      toggleSearchVertical(openedSearchVertical, { withInspirations: false })
      setSearchType(destinationSearchToggle)
      if (onSelectDestination) {
        onSelectDestination()
      }
    } else {
      toggleSearchVertical(openedSearchVertical, { withInspirations: true })
      addGTMEvent(plmTabClick())
      setSearchType(inspirationSearchToggle)
      if (onSelectInspiration) {
        onSelectInspiration()
      }
    }
  }, [inspirationSearchToggle, onSelectDestination, onSelectInspiration, openedSearchVertical, toggleSearchVertical])

  return (
    <StyledContainer>
      <StyledButtonGroupToggle
        items={[destinationSearchToggle, inspirationSearchToggle]}
        onItemClick={onButtonToggle}
        activeItem={searchType}
      />
    </StyledContainer>
  )
}

export default connect<MappedStateProps, undefined, Props, App.State>((appState) =>
{
  const variant = getPeopleLikeMeEntryExperimentVariant(appState)
  const inspirationTabText = variant === '1' ? 'Don’t know where next' : 'Give me suggestions'
  return {
    inspirationTabText,
  }
},
)(SearchTypeToggle)
